import styled from "styled-components"
import colors from "../styles/colors"
import theme from "styled-theming";
import { ThemeType } from "../styles/theme";
import ReactPaginate, { ReactPaginateProps } from "react-paginate";

export const backgroundColor = theme("mode", {
    [ThemeType.light]: colors.white,
    [ThemeType.dark]: colors.dark
});

const hoverBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.grey_4,
    [ThemeType.dark]: colors.grey_2,
});

const selectedBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.grey_3,
    [ThemeType.dark]: colors.dark2,
});

const color = theme("mode", {
    [ThemeType.light]: colors.grey_1,
    [ThemeType.dark]: colors.grey_3
});

const hoverColor = theme("mode", {
    [ThemeType.light]: colors.black,
    [ThemeType.dark]: colors.black
});

export interface PagninateProps extends ReactPaginateProps {
    center?: boolean;
    disabled?: boolean;
    width?: number; // Width in pixels, defaults to 600 if not provided
}

export const Pagination = styled(ReactPaginate) <PagninateProps>`
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none; 
    justify-content:  ${props => props.center ? "center" : "inherit"};
    pointer-events: ${props => props.disabled ? "none" : "auto"};
    
    ${props => props.width !== undefined && `
        width: ${props.width}px; /* Customizable width for pagination */
        
        /* This ensures the pagination stays centered */
        > ul {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
        
        /* Make each page item take equal space within the container */
        .page-item, .break {
            flex: 1;
            min-width: 0;
            text-align: center;
        }
        
        /* Fixed width for previous/next buttons - they will always be exactly the same size */
        .previous, .next {
            flex: 0 0 90px;
        }
    `}

    .${props => props.pageLinkClassName} {
        border: 2px solid ${colors.grey_2};
        padding: 8px 15px;
        display: block;
        background-color: ${backgroundColor};
        transition: background-color .15s ease-in-out;
        ${props => props.width !== undefined && `
            display: flex !important;
            justify-content: center;
            align-items: center;
        `}
    }
    .${props => props.pageLinkClassName}:hover {
        z-index: 2;
        background-color: ${hoverBackgroundColor};
        color: ${hoverColor};
    }

    .${props => props.pageClassName}:not(:first-child) .${props => props.pageLinkClassName} {
        margin-left: -2px;
    }

    .${props => props.pageClassName}:first-child .${props => props.pageLinkClassName} {
        border-radius: 20px 0px 0px 20px;
        padding: 8px 10px 8px 16px;
        color: ${color};
        &:hover  {
            color: ${hoverColor};
        }
    }

    .${props => props.pageClassName}:last-child .${props => props.pageLinkClassName} {
        padding: 8px 16px 8px 10px;
        border-radius: 0px 20px 20px 00px;
        color: ${color};
        &:hover  {
            color: ${hoverColor};
        }
    }

    .${props => props.pageClassName} {
        cursor: pointer;
        a {
            color: ${color};
        }
    }

    .disabled {
        cursor: auto;
        .${props => props.pageLinkClassName} {
            color: ${colors.grey_2} !important;
            :hover {
                background-color: ${backgroundColor};
            }
        }
    }
    .selected .${props => props.pageLinkClassName}  {
        background-color: ${selectedBackgroundColor};
        color: ${color};
    }
`;